<script lang="ts" setup>
import type { NewGroupProps, Suggestion } from '.';

import { CommandGroup } from '@/components/SearchSuggestRadixCommand';
import { cn } from '@/utils';

import NewGroupItem from './NewGroupItem.vue';

const emit = defineEmits<{
	(e: 'remove-suggestion', suggestion: Suggestion): void;
}>();

withDefaults(defineProps<NewGroupProps>(), {
	isSelection: false,
	isRemovable: false
});
</script>

<template>
	<CommandGroup class="p-0">
		<template #heading>
			<div
				:class="
					cn(
						'flex h-12 cursor-default items-center gap-3 px-4 font-matter-sq text-lg font-normal leading-normal tracking-[-0.36px] text-primary',
						groupHeadingClasses
					)
				"
			>
				<component :is="heading.icon" :class="cn('size-5', groupIconClasses)" />

				{{ heading.text }}
			</div>
		</template>

		<NewGroupItem
			v-for="suggestion in suggestions"
			:key="`suggest-item-${suggestionKey}-${suggestion.result.title}`"
			:suggestion="suggestion"
			:is-removable="isRemovable"
			:group-item-wrapper-classes="groupItemWrapperClasses"
			:group-item-text-classes="groupItemTextClasses"
			:group-item-sub-text-classes="groupItemSubTextClasses"
			:search-term="searchTerm"
			@remove-suggestion="emit('remove-suggestion', suggestion as Suggestion)"
		/>
	</CommandGroup>
</template>
